import { render, staticRenderFns } from "./topnavbar.vue?vue&type=template&id=30c67712"
import script from "./topnavbar.vue?vue&type=script&lang=js"
export * from "./topnavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports